import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CtrlSortListIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M1.625 10.875H0.625C0.279822 10.875 0 11.1548 0 11.5V12.5C0 12.8452 0.279822 13.125 0.625 13.125H1.625C1.97018 13.125 2.25 12.8452 2.25 12.5V11.5C2.25 11.1548 1.97018 10.875 1.625 10.875Z"
        fill={color}
      />
      <path
        d="M1.625 18H0.625C0.279822 18 0 18.2798 0 18.625V19.625C0 19.9702 0.279822 20.25 0.625 20.25H1.625C1.97018 20.25 2.25 19.9702 2.25 19.625V18.625C2.25 18.2798 1.97018 18 1.625 18Z"
        fill={color}
      />
      <path
        d="M1.625 3.75H0.625C0.279822 3.75 0 4.02982 0 4.375V5.375C0 5.72018 0.279822 6 0.625 6H1.625C1.97018 6 2.25 5.72018 2.25 5.375V4.375C2.25 4.02982 1.97018 3.75 1.625 3.75Z"
        fill={color}
      />
      <path
        d="M23.375 10.875H6C5.65482 10.875 5.375 11.1548 5.375 11.5V12.5C5.375 12.8452 5.65482 13.125 6 13.125H23.375C23.7202 13.125 24 12.8452 24 12.5V11.5C24 11.1548 23.7202 10.875 23.375 10.875Z"
        fill={color}
      />
      <path
        d="M23.375 18H6C5.65482 18 5.375 18.2798 5.375 18.625V19.625C5.375 19.9702 5.65482 20.25 6 20.25H23.375C23.7202 20.25 24 19.9702 24 19.625V18.625C24 18.2798 23.7202 18 23.375 18Z"
        fill={color}
      />
      <path
        d="M23.375 3.75H6C5.65482 3.75 5.375 4.02982 5.375 4.375V5.375C5.375 5.72018 5.65482 6 6 6H23.375C23.7202 6 24 5.72018 24 5.375V4.375C24 4.02982 23.7202 3.75 23.375 3.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CtrlSortListIcon.displayName = 'CtrlSortListIcon';
